import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Coins } from 'lucide-react';
import { cn } from '../../lib/cn.js';
import { Skeleton } from '../../primitives/Skeleton/Skeleton.js';
import styles from './CreditsIndicator.module.css';
/**
 * Top-bar credits pill shell (F47). Full delta-animation (+N/−N coalesced)
 * and the Buy/Upgrade quick menu are owned by the consuming app (this
 * package ships the shell states: skeleton, populated, low, zero,
 * impersonation-read-only, compact) — WS-BILL wires the live balance +
 * menu on top of this shell.
 */
export function CreditsIndicator({ credits, formattedCredits, label, low = false, zero = false, impersonating = false, onClick, className, }) {
    if (credits === null) {
        return (_jsxs("span", { className: cn(styles['pill'], className), "aria-label": label, children: [_jsx(Coins, { size: 14, className: styles['icon'], "aria-hidden": "true" }), _jsx(Skeleton, { shape: "text-line", width: "2.5em" })] }));
    }
    const tone = zero ? styles['zero'] : low ? styles['low'] : undefined;
    const interactive = Boolean(onClick) && !impersonating;
    const content = (_jsxs(_Fragment, { children: [_jsx(Coins, { size: 14, className: styles['icon'], "aria-hidden": "true" }), _jsx("span", { className: styles['count'], children: formattedCredits ?? credits })] }));
    if (interactive) {
        return (_jsx("button", { type: "button", onClick: onClick, className: cn(styles['pill'], tone, styles['interactive'], className), "aria-label": label, children: content }));
    }
    return (_jsx("span", { className: cn(styles['pill'], tone, className), "aria-label": label, children: content }));
}
